<template>
    <div id="appCapsule">
        <!-- Wallet Card -->
        <div class="section wallet-card-section pt-1">
            <div class="wallet-card">
                <!-- Balance -->
                <div class="csbal-container">
                    <span class="title">Available Balance</span>
                    <div class="balance">
                        <div class="left">
                            <h1
                                class="total cus-available-bal"
                                id="appTotalBal"
                            >
                                {{ currency }}{{ balance }}
                            </h1>
                        </div>
                        <div class="right">
                            <a
                                href="javascript:void(0)"
                                class="button acc-selector-btn"
                            >
                                <ion-icon name="chevron-down-outline" />
                            </a>
                        </div>
                    </div>
                </div>
                <!-- * Balance -->

                <div class="choose-acc-card" style="display: none" v-if="user">
                    <div class="choose-acc-card-inner">
                        <ul class="choose-acc-card-ul">
                            <li
                                class="choose-acc-card-li csli-acc-btn showing-account"
                            >
                                <div class="cs-acc-card-li-desc">
                                    <div class="cs-acc-type">
                                        <div class="cs-acc-type-icon">
                                            <svg
                                                version="1.0"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="40"
                                                height="40"
                                                viewBox="0 0 512.000000 512.000000"
                                                preserveAspectRatio="xMidYMid meet"
                                            >
                                                <g
                                                    transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                                    fill="#000000"
                                                    stroke="none"
                                                >
                                                    <path
                                                        d="M2166 5059 c-386 -56 -713 -334 -829 -704 -90 -288 -43 -619 124 -866 54 -80 166 -199 243 -255 34 -26 53 -46 45 -48 -8 -3 -39 -12 -69 -21 -89 -28 -119 -71 -89 -126 19 -37 51 -40 143 -13 372 108 763 109 1124 5 57 -16 111 -27 120 -24 35 13 52 36 52 74 0 46 -20 63 -100 85 -30 8 -61 17 -69 20 -10 3 -1 13 25 31 73 49 162 133 215 203 59 78 55 77 160 49 l35 -9 -14 -77 c-8 -50 -12 -120 -9 -193 7 -190 62 -318 185 -432 110 -101 247 -152 412 -151 140 1 217 28 290 101 37 38 66 80 85 124 17 37 33 68 37 68 14 0 117 -155 157 -235 22 -44 51 -110 64 -148 29 -81 59 -126 102 -156 18 -12 93 -42 167 -67 102 -34 142 -52 164 -75 l29 -30 0 -229 0 -229 -30 -31 c-24 -25 -64 -42 -228 -95 -120 -39 -213 -75 -233 -90 -18 -14 -63 -70 -98 -124 -114 -173 -276 -326 -464 -438 -131 -78 -162 -101 -172 -127 -5 -14 -34 -156 -64 -316 -30 -160 -58 -295 -61 -300 -4 -6 -85 -10 -201 -10 -192 0 -195 0 -204 23 -5 12 -23 94 -40 182 -42 227 -60 245 -214 226 -187 -24 -405 -31 -603 -20 -262 16 -257 20 -303 -226 -17 -87 -35 -164 -41 -172 -16 -18 -382 -19 -396 -1 -6 7 -34 137 -63 288 -29 151 -59 288 -67 303 -8 16 -28 36 -45 45 -256 141 -470 355 -587 590 -45 89 -97 250 -117 362 -22 117 -25 418 -5 530 69 401 253 689 579 903 98 64 113 86 96 136 -5 14 -23 32 -39 40 -27 13 -33 12 -80 -13 -148 -82 -323 -236 -428 -377 -139 -186 -217 -371 -273 -646 -8 -39 -21 -25 -27 28 -22 182 -186 327 -326 289 -86 -23 -171 -132 -171 -219 0 -104 98 -191 263 -232 l49 -12 -49 -49 c-60 -62 -125 -95 -216 -113 -103 -20 -134 -67 -85 -130 20 -26 24 -27 98 -23 64 2 88 9 153 41 85 42 196 143 232 210 13 24 27 37 40 37 19 0 20 -5 17 -73 -5 -89 13 -292 34 -396 37 -180 116 -370 222 -531 100 -151 310 -343 493 -451 l44 -26 48 -254 c27 -140 55 -273 63 -296 18 -50 69 -98 121 -113 25 -8 112 -10 248 -8 199 3 212 4 247 26 57 35 74 73 106 237 l29 150 44 -1 c292 -9 574 -1 729 19 11 2 19 -22 32 -93 38 -203 49 -240 79 -275 53 -60 87 -67 330 -63 l216 3 42 28 c28 18 49 43 61 70 10 23 42 168 71 323 l53 281 50 28 c240 133 460 338 598 556 40 63 28 57 268 134 221 71 268 104 310 213 18 47 20 76 20 272 0 196 -2 225 -20 272 -39 101 -93 142 -265 198 -74 24 -139 51 -151 64 -12 11 -38 64 -57 116 -57 148 -134 273 -267 432 l-30 36 16 89 c21 113 30 398 15 478 -16 86 -58 165 -101 190 -93 53 -325 1 -694 -156 -77 -33 -151 -67 -162 -74 -16 -10 -31 -12 -55 -5 -19 5 -53 14 -75 19 l-42 11 25 62 c31 76 63 225 63 296 0 63 -23 92 -73 92 -50 0 -68 -26 -77 -113 -34 -300 -210 -556 -473 -688 l-77 -39 -160 12 c-124 9 -193 9 -310 -1 -151 -12 -151 -12 -204 12 -229 105 -406 314 -478 562 -19 68 -23 102 -22 230 1 133 4 160 27 238 46 150 115 265 224 374 395 396 1066 311 1353 -170 58 -98 93 -116 144 -76 41 32 35 71 -26 169 -100 163 -284 322 -461 396 -171 72 -366 98 -541 73z m2036 -1386 c9 -27 13 -94 12 -228 0 -156 -4 -208 -22 -293 -28 -130 -75 -260 -113 -312 -55 -75 -173 -105 -305 -77 -178 38 -295 146 -339 312 -29 113 -12 338 29 384 19 21 221 112 372 167 123 45 267 83 316 84 33 0 38 -3 50 -37z m-3876 -1143 c33 -21 84 -107 84 -141 0 -17 -3 -17 -64 0 -80 22 -130 51 -134 78 -4 24 43 83 65 83 9 0 30 -9 49 -20z"
                                                    />
                                                    <path
                                                        d="M2312 4578 c-7 -7 -12 -22 -12 -34 0 -17 -8 -23 -37 -29 -104 -18 -183 -88 -204 -179 -28 -128 34 -233 172 -288 l64 -26 3 -156 3 -157 -28 7 c-48 12 -87 30 -127 63 -46 37 -79 40 -100 9 -54 -76 50 -179 199 -197 45 -5 50 -9 53 -34 7 -58 82 -56 82 2 0 25 5 30 43 39 141 36 219 171 188 324 -7 30 -23 70 -36 88 -31 42 -102 92 -154 110 l-41 13 0 134 c0 152 -2 149 90 113 28 -11 59 -20 69 -20 29 0 53 34 49 71 -2 28 -10 38 -46 57 -25 14 -67 26 -102 29 -53 5 -60 8 -60 27 0 26 -18 46 -40 46 -9 0 -21 -5 -28 -12z m-2 -298 l0 -120 -50 25 c-56 28 -72 52 -74 106 -1 42 22 74 69 95 55 24 55 24 55 -106z m109 -314 c53 -34 79 -99 62 -156 -12 -42 -61 -90 -92 -90 -18 0 -19 8 -19 135 0 74 2 135 5 135 3 0 23 -11 44 -24z"
                                                    />
                                                    <path
                                                        d="M3830 2383 c-53 -68 23 -222 132 -267 51 -22 143 -20 193 3 109 49 179 196 125 264 -42 53 -130 21 -130 -49 0 -12 -12 -36 -26 -53 -21 -26 -33 -31 -69 -31 -36 0 -48 5 -69 31 -15 18 -26 43 -26 60 0 67 -88 95 -130 42z"
                                                    />
                                                </g>
                                            </svg>
                                        </div>
                                        <div
                                            class="cs-acc-type-desc"
                                            v-if="user"
                                        >
                                            {{ account.type }} ****
                                            {{ account.number.slice(-4) }}
                                        </div>
                                    </div>
                                    <div class="cs-acc-card-li-action">
                                        <ion-icon
                                            name="ellipsis-horizontal-outline"
                                        ></ion-icon>
                                    </div>
                                </div>

                                <div class="cs-acc-bals-dyno">
                                    <div class="cs-acc-bals-label">Current</div>
                                    <div class="cs-acc-bals-txt">
                                        {{ user.currency }}{{ user.balance }}
                                    </div>
                                </div>

                                <div class="cs-acc-bals-dyno">
                                    <div class="cs-acc-bals-label">
                                        Available
                                    </div>
                                    <div class="cs-acc-bals-txt">
                                        {{ user.currency }}{{ user.balance }}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Wallet Footer -->
                <div class="wallet-footer">
                    <div class="item">
                        <a
                            href="javascript:void(0)"
                            data-bs-toggle="modal"
                            data-bs-target="#sendActionSheet"
                        >
                            <div class="icon-wrapper">
                                <ion-icon
                                    name="arrow-forward-outline"
                                ></ion-icon>
                            </div>
                            <strong>Transfer</strong>
                        </a>
                    </div>
                    <div class="item">
                        <a
                            href="javascript:void(0)"
                            data-bs-toggle="modal"
                            data-bs-target="#depositActionSheet"
                        >
                            <div class="icon-wrapper bg-danger">
                                <ion-icon name="arrow-down-outline"></ion-icon>
                            </div>
                            <strong>Deposit</strong>
                        </a>
                    </div>
                    <div class="item link-loader">
                        <a href="/m/transactions">
                            <div class="icon-wrapper bg-warning">
                                <ion-icon name="swap-vertical"></ion-icon>
                            </div>
                            <strong>History</strong>
                        </a>
                    </div>
                    <div class="item link-loader">
                        <a href="/m/cards">
                            <div class="icon-wrapper bg-success">
                                <ion-icon name="card-outline"></ion-icon>
                            </div>
                            <strong>My Cards</strong>
                        </a>
                    </div>
                </div>
                <!-- * Wallet Footer -->
            </div>
        </div>
        <!-- Wallet Card -->

        <!-- Stats -->
        <div class="section" id="appCharts">
            <div class="row mt-2">
                <div class="col-6">
                    <div class="mt-stat-box sbox-income">
                        <div class="mt-stat-box-inner">
                            <div class="mt-sbox-col-one">
                                <div class="mt-sbox-bar">
                                    <div
                                        class="mt-pie"
                                        :style="`--percent: ${exPer}%; --skin: #50aeb3`"
                                    >
                                        <div class="mt-pie-center">
                                            <div class="mt-pie-center-txt">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <line
                                                        x1="17"
                                                        y1="7"
                                                        x2="7"
                                                        y2="17"
                                                    ></line>
                                                    <polyline
                                                        points="17 17 7 17 7 7"
                                                    ></polyline>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-sbox-col-two">
                                <div class="title">Income</div>
                                <div class="mt-sbox-value">
                                    {{ currency }}{{ income }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="mt-stat-box sbox-expenses">
                        <div class="mt-stat-box-inner">
                            <div class="mt-sbox-col-one">
                                <div class="mt-sbox-bar">
                                    <div
                                        class="mt-pie"
                                        :style="`--percent: ${inPer}%; --skin: #2a7ade`"
                                    >
                                        <div class="mt-pie-center">
                                            <div class="mt-pie-center-txt">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <line
                                                        x1="7"
                                                        y1="17"
                                                        x2="17"
                                                        y2="7"
                                                    ></line>
                                                    <polyline
                                                        points="7 7 17 7 17 17"
                                                    ></polyline>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-sbox-col-two">
                                <div class="title">Expenses</div>
                                <div class="mt-sbox-value">
                                    {{ currency }}{{ expense }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- * Stats -->

        <!-- Transactions -->
        <div class="section mt-4 tr-history-sec app-index-history">
            <div class="mt-mtransactions">
                <div class="app-transaction-history">
                    <ul id="transactionHistory" class="list-unstyled mg-b-0">
                        <span v-for="log in logs" :key="log.id">
                            <li
                                v-if="log.is_credit == 1"
                                class="list-item mt-trs-li credit"
                                @click.prevent="viewData(log.id, log.is_transfer)"
                            >
                                <div class="media align-items-center">
                                    <div class="mt-trs-icon-group">
                                        <div class="mt-trs-icon-avatar">
                                            <span
                                                class="mt-trs-icon-avatar-txt"
                                                >{{ log.type }}</span
                                            >
                                        </div>
                                        <div
                                            class="mtx-info wd-35 ht-35 bd bd-2 bd-info rounded-circle align-items-center justify-content-center d-sm-flex"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 512 512"
                                            >
                                                <path
                                                    fill="none"
                                                    stroke="currentColor"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    stroke-width="32"
                                                    d="M416 128L192 384l-96-96"
                                                ></path>
                                            </svg>
                                        </div>
                                    </div>

                                    <div class="media-body mg-sm-l-15">
                                        <p
                                            class="mt-trs-details tx-medium mg-b-0"
                                        >
                                            {{ log.detail.slice(0, 30) }}
                                        </p>
                                        <p
                                            class="mt-trs-date tx-12 mg-b-0 tx-color-03"
                                        >
                                            {{
                                                new Date(
                                                    log.created_at
                                                ).toDateString()
                                            }}
                                        </p>
                                    </div>
                                    <!-- media-body -->
                                </div>
                                <!-- media -->
                                <div class="text-right tx-rubik">
                                    <p class="mt-trs-amt mg-b-0">
                                        +{{ log.currency.symbol
                                        }}{{ log.amount }} ({{
                                            log.currency.code
                                        }})
                                    </p>
                                    <p
                                        class="mt-trs-status tx-12 mg-b-0 tx-success"
                                    >
                                        <span class="itrr-type">Credit</span>
                                        Completed
                                    </p>
                                  
                                </div>
                                <!-- media-body -->
                            </li>

                            <li
                                v-if="log.is_credit == 0"
                                class="list-item mt-trs-li debit"
                                    @click.prevent="viewData(log.id, log.is_transfer)"
                            >
                                <div class="media align-items-center">
                                    <div class="mt-trs-icon-group">
                                        <div class="mt-trs-icon-avatar">
                                            <span
                                                class="mt-trs-icon-avatar-txt"
                                            >
                                                {{ log.type }}
                                            </span>
                                        </div>
                                        <div
                                            class="mtx-info wd-35 ht-35 bd bd-2 bd-info rounded-circle align-items-center justify-content-center d-sm-flex"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 512 512"
                                            >
                                                <path
                                                    fill="none"
                                                    stroke="currentColor"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    stroke-width="32"
                                                    d="M416 128L192 384l-96-96"
                                                ></path>
                                            </svg>
                                        </div>
                                    </div>

                                    <div class="media-body mg-sm-l-15">
                                        <p
                                            class="mt-trs-details tx-medium mg-b-0"
                                        >
                                            {{ log.detail.slice(0, 20) }}
                                        </p>
                                        <p
                                            class="mt-trs-date tx-12 mg-b-0 tx-color-03"
                                        >
                                            {{
                                                new Date(
                                                    log.created_at
                                                ).toDateString()
                                            }}
                                        </p>
                                    </div>
                                    <!-- media-body -->
                                </div>
                                <!-- media -->
                                <div class="text-right tx-rubik">
                                    <p class="mt-trs-amt mg-b-0">
                                        -{{ log.currency.symbol
                                        }}{{
                                            log.amount
                                        }}
                                        ({{ log.currency.code }})
                                    </p>
                                    <p v-if="log.status == 1"
                                        class="mt-trs-status tx-12 mg-b-0 tx-success"
                                    >
                                        <span class="itrr-type">Debit</span>
                                        Completed
                                    </p>
                                    <p v-if="log.status == 0" style="color: orange"
                                        class="mt-trs-status tx-12 mg-b-0"
                                    >
                                        <span class="itrr-type">Debit</span>
                                        Pending
                                    </p>
                                </div>
                                <!-- media-body -->
                            </li>
                        </span>

                        <div class="master-pagination">
                            <ul class="pagination mg-b-0">
                                <li class="page-item disabled">
                                    <a
                                        class="page-link page-link-icon"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="feather feather-chevron-left"
                                        >
                                            <polyline
                                                points="15 18 9 12 15 6"
                                            ></polyline></svg
                                    ></a>
                                </li>

                                <li class="page-item active">
                                    <a class="page-link">1</a>
                                </li>
                                <li class="page-item">
                                    <a
                                        class="page-link"
                                        href="javascript:void(0);"
                                        onclick="historyPages('2','04100211846');"
                                        >2</a
                                    >
                                </li>
                                <li class="page-item">
                                    <a
                                        class="page-link"
                                        href="javascript:void(0);"
                                        onclick="historyPages('3','04100211846');"
                                        >3</a
                                    >
                                </li>
                                <li class="page-item">
                                    <a
                                        class="page-link"
                                        href="javascript:void(0);"
                                        onclick="historyPages('4','04100211846');"
                                        >4</a
                                    >
                                </li>
                                <li class="page-item">
                                    <a
                                        class="page-link"
                                        href="javascript:void(0);"
                                        onclick="historyPages('5','04100211846');"
                                        >5</a
                                    >
                                </li>
                                <li>
                                    <a
                                        class="page-link page-link-icon"
                                        href="javascript:void(0);"
                                        onclick="historyPages('2','04100211846')"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="feather feather-chevron-right"
                                        >
                                            <polyline
                                                points="9 18 15 12 9 6"
                                            ></polyline></svg
                                    ></a>
                                </li>
                            </ul>
                        </div>
                    </ul>
                    <div id="actionLoader"></div>
                </div>
            </div>
        </div>
        <!-- <SendAction /> -->
    </div>
</template>

<script>
import { RepositoryFactory } from "../../../repository/RepositoryFactory";
const UsersRepository = RepositoryFactory.get("users");

export default {
    // components: { SendAction },
    data() {
        return {
            user: null,
            account: {},
            currency: null,
            income: 0,
            expense: 0,
            balance: 0,
            exPer: 0,
            inPer: 0
        };
    },
    methods: {
        viewData(id, type){
            viewHis(id, type);
        },
        userAccounts() {
            UsersRepository.loggedInUser().then(response => {
                this.user = response.data;
                this.account = response.data.accounts[0];
                this.currency = response.data.currency;
                this.balance = response.data.balance;
                const income = response.data.income;
                const expense = response.data.expense;
                this.logs = response.data.logs.data;
                this.expense = expense;
                this.income = income;
                const totalEx = parseInt(expense.replace(',',''));
                const totalInc = parseInt(income.replace(',',''));
                const total = parseInt(totalEx) + parseInt(totalInc);
                this.exPer = (totalEx / total) * 100;
                this.inPer = (totalInc / total) * 100;

            });
        }
    },

    created() {
        this.userAccounts();
    }
};
</script>
